import { GET_ATTRIBUTES, GET_ATTRIBUTES_SUCCESS, GET_ATTRIBUTES_ERROR, GET_ATTRIBUTES_EMPTY } from './../../../actionType.js';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const GetAttributes = (state = initialState, action) => {
  switch (action.type) {
    case GET_ATTRIBUTES:
      state = {
        ...state,
        // data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case GET_ATTRIBUTES_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case GET_ATTRIBUTES_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case GET_ATTRIBUTES_EMPTY:
      state = { ...initialState };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default GetAttributes;
